import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      stroke: "currentColor",
      d: "m19.744 19.822-.46-.508-4.925-5.438-2.236 3.872.823 2.005.093.227-1.194 2.068-.46-.484-2.301-2.415-3.241-.785-.65-.157 1.194-2.068.244-.032 2.146-.29 2.236-3.872-7.17-1.546-.671-.145 1.461-2.531.273-.014 8.796-.422 2.565-4.443c.539-.933 1.723-1.284 2.66-.743.937.54 1.225 1.741.686 2.675l-2.565 4.442 4.033 7.83.124.243z"
    }, null, -1)
  ])))
}
export default { render: render }